import { IDotThiActionTypes } from "../../action-types/tct/IDotThiActions";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
import { IDotThiReducer } from "../../reducer-model/tct/IDotThiReducer";
const iniState: IDotThiReducer = {
  status: eReducerStatusBase.is_not_initialization,
  dotThis: [],
  nam_hoc: "",
  hoc_ky: 0
};
export const dotThiReducer = (
  state: IDotThiReducer = iniState,
  action: IDotThiActionTypes
): IDotThiReducer => {
  switch (action.type) {
    case "DOT_THI_LOAD_START":
      return {
        ...state,
        status: eReducerStatusBase.is_loading,
        nam_hoc: action.payload.nam_hoc,
        hoc_ky: action.payload.hoc_ky
      };
    case "DOT_THI_LOAD_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
        dotThis: action.payload,
      };
    case "DOT_THI_LOAD_ERROR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    case "DOT_THI_SHOW_EDIT_MODAL":
      return {
        ...state,
        dotThiEditing: action.payload,
        isShowEditModal: true
      };
    case "DOT_THI_CLOSE_EDIT_MODAL":
      return {
        ...state,
        isShowEditModal: false
      };
    case "DOT_THI_SAVE_START":
      return {
        ...state,
        status: eReducerStatusBase.is_saving
      };
    case "DOT_THI_SAVE_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_need_reload,
        isShowEditModal: false
      };
    case "DOT_THI_SAVE_ERROR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed
      };
    case "DOT_THI_DELETE_START":
      return {
        ...state,
        status: eReducerStatusBase.is_deleting
      };
    case "DOT_THI_DELETE_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_need_reload
      };
    case "DOT_THI_DELETE_ERROR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed
      };

    default:
      return state;
  }
};
